const getTokenFromLocalStorage = () => {
  const customer = localStorage.getItem("customer");
  return customer ? JSON.parse(customer) : null;
};

export const base_url =
  window.location.hostname === "localhost"
    ? "http://localhost:4000/api/"
    : "https://pulseback.greenafricafarm.com/api/";

export const config = {
  get headers() {
    const user = getTokenFromLocalStorage();
    return {
      Authorization: `Bearer ${user !== null ? user.token : ""}`,
      Accept: "application/json",
    };
  },
};
